<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :backButtonEnable="false"
  >
    <template #headerContent>
      <GcHeaderContentStatic
        title="MRP Outstanding Sales Forecast"
        :screenName="getScreenName"
      />
    </template>

    <div class="css-v2 grid-report">
      <gc-data-grid-report
        v-if="report.dataSourceConfig"
        :exportFileName="report.exportFileName"
        :dataSourceConfig="reportDataSourceConfig"
        :columns="columns"
        :gridOptions="gridOptions"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
        :gridToolbar="gridToolbar"
      >
      </gc-data-grid-report>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import GcDataGridReport from "@/components/gc-data-grid-report";
import { ScreenLayoutService } from "@/_services/api/reports/screen-layout.service";
import { CommonStorage } from "@/_services/storage";
import { getGlobalField } from "@/_store/helpers";

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin],
  components: {
    GcDataGridReport,
  },

  data() {
    return {
      persistenceKey: "report-mrp-outstanding-sales-forcast",
      report: {
        title: "",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        columns: [],
      },
      gridOptions: {
        noDataMessage: {
          addNew: {
            class: "no-data",
            title: "No Transactions",
            message:
              "Currently there are no transactions to display in this report.",
          },
        },
      },
      gridToolbar: {
        search: false,
        columnChooser: true,
        export: true,
        openFilter: true,
        filterOnEnter: true,
      },

      tabs: [],
    };
  },
  computed: {
    reportDataSourceConfig() {
      var config = this.report.dataSourceConfig;
      // config.filter = [["CustomerCode", "=", this.model.Code]];
      return config;
    },

    columns() {
      var cols = this.report.columns;

      return cols;
    },
    getScreenName() {
      return "MRP Outstanding Sales Forecast";
    },
  },

  async created() {
    CommonStorage.clear("go_back_route");

    // Get the screen layout
    let response = await ScreenLayoutService.getByRoute(
      "crop-tracker-outstanding-sales-forcast"
    );
    if (response.data.value) {
      let config = JSON.parse(response.data.value[0].Definition);

      // Get the grid data fields
      let select = [];
      config.columns.forEach((column) => {
        if (!column.gridDataField && !column.dataField) {
          let globalField = getGlobalField(column.screenField);
          if (globalField.gridDataField) select.push(globalField.gridDataField);
          else if (globalField.dataField) select.push(globalField.dataField);
        } else {
          if (column.gridDataField) select.push(column.gridDataField);
          if (column.dataField) select.push(column.dataField);
        }
      });

      var url = window.location.href;
      if (url.indexOf("?") != -1) {
        if (Object.keys(this.baseView.query).length != 0) {
          CommonStorage.clear("filter-panel-" + this.persistenceKey);
          CommonStorage.clear(this.persistenceKey);
          config.columns.forEach((element) => {
            if (element.filterDefaultValue != undefined)
              element.filterDefaultValue = undefined;

            if (this.baseView.query[element.screenField] != undefined)
              element.filterDefaultValue = JSON.parse(
                this.baseView.query[element.screenField]
              );
          });
        }
      }

      // Set the grid data fields
      // if (select.length > 0)
      //   config.dataSourceConfig.select = ["ICFlag"].concat(select);
      this.report = { ...config };
    }
  },
  methods: {},
};
</script>
